import { useStrict } from 'mobx';

/**
 * Enable MobX strict mode
 * https://github.com/mobxjs/mobx/blob/gh-pages/docs/refguide/api.md#usestrict
 */
useStrict(true);

export { default as AppState } from './App';
export { default as SearchState } from './Search';
export { default as ProductsState } from './Products';
export { default as OrdersState } from './Orders';
export { default as ItemsState } from './Items';
export { default as UIState } from './UI';
export { default as CartState } from './Cart';
export { default as ConfirmPromptState } from './ConfirmPrompt';
export { default as CartItemsState } from './CartItems';



// WEBPACK FOOTER //
// ./src/state/index.js